<h4 class="fw-bold">
    @if (pageMode() === PageMode.create) {
        {{ "government_scores.pillars.create" | translate }}
    } @else if (pageMode() === PageMode.view) {
        {{ "government_scores.pillars.view" | translate }}
    } @else if (pageMode() === PageMode.edit) {
        {{ "government_scores.pillars.edit" | translate }}
    }
</h4>

<div class="bg-card shadow-md rounded p-2 mb-2">
    <adaa-form-dropdown
        [label]="'common.form.label.entity' | translate"
        [required]="true"
        [options]="availableEntitiesOptions()"
        [setDefaultValue]="entityId"
        [isDisabled]="pageMode() !== PageMode.create"
        [invalid]="submitted() && !entityId"
        (inputChanges)="entityId = $event"
    />
</div>

<div class="bg-card shadow-md rounded p-2">
    <adaa-data-table
        #adaaDataTable
        [apiPrefix]="'govScoresSector'"
        [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.GOV_ENTITY_PILLARS_STEP_CONF"
        [titleHeader]="'government_scores.pillars.title_plural' | translate"
        [isLocalData]="true"
        [localData]="pillars()"
        [enableAdd]="pageMode() !== PageMode.view"
        [enableViewAction]="pageMode() === PageMode.view"
        [enableEditAction]="pageMode() !== PageMode.view"
        [enableDeleteAction]="pageMode() !== PageMode.view"
        (addNewClicked)="pillarsModal.open()"
        (actionClicked)="getAction($event)"
    ></adaa-data-table>
</div>

<div class="my-2">
    <adaa-form-action-buttons
        [showSaveButton]="pageMode() !== PageMode.view"
        [saveButtonTitle]="'common.form.button.submit' | translate"
        [cancelButtonTitle]="pageMode() === PageMode.view ? ('common.form.button.close' | translate) : ('common.form.button.cancel' | translate)"
        (cancelClicked)="close()"
        (saveClicked)="submit()"
    ></adaa-form-action-buttons>
</div>

<adaa-entity-pillars [pageMode]="pageMode()" [pillars]="pillars()" (pillarOutput)="addPillar($event)" #pillarsModal />
